/**
 * @deprecated Use the Column component from OPL (/OPL/Grid/Column.ts)
 * thanks <3
 */

import styled from 'styled-components';

interface ColumnProps {
  width?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  offset?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  textAlign?: 'left' | 'center' | 'right';
  theme?: any;
  truncate?: boolean;
}

const Column = styled.div<ColumnProps>`
  ${({ width = 1, offset = 0, textAlign = 'left', theme, truncate }) => `
    flex-grow: 0;
    flex-shrink: 0;
    padding: 0 ${theme.legacy.grid.gutter / 2}px;
    margin-left: ${(offset / 12) * 100}%;
    text-align: ${textAlign};
    width: ${(width / 12) * 100}%;
    box-sizing: border-box;
    white-space: ${truncate && 'nowrap'};
    text-overflow: ${truncate && 'ellipsis'};
    overflow: ${truncate && 'hidden'};
  `}

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`;

export default Column;
